module.exports = __webpack_public_path__ + "static/media/modelo.3bdf9273.png";